import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'lib-humanresources-common-shared',
    template: ` <p>humanresources-common-shared works!</p> `,
    styles: [],
})
export class HumanresourcesCommonSharedComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
